var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 25.4383V11.4171C30 10.6734 29.705 9.96011 29.1799 9.43422C28.6548 8.90832 27.9426 8.61287 27.2 8.61287H17.7304C17.2103 8.61286 16.7005 8.46776 16.2581 8.19386C15.8157 7.91996 15.4583 7.52807 15.2258 7.06213L13.9742 4.55514C13.7416 4.08898 13.3839 3.69695 12.9413 3.42304C12.4986 3.14912 11.9885 3.00415 11.4682 3.00439H4.8C4.05739 3.00439 3.3452 3.29984 2.8201 3.82574C2.295 4.35163 2 5.0649 2 5.80863V25.4383C2 26.182 2.295 26.8953 2.8201 27.4212C3.3452 27.9471 4.05739 28.2426 4.8 28.2426H27.2C27.9426 28.2426 28.6548 27.9471 29.1799 27.4212C29.705 26.8953 30 26.182 30 25.4383Z",
    stroke: "#F55095",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.43a55606b2d53f85ac55bee0694484f4.svg";
export { ForwardRef as ReactComponent };